import { render } from "./FormNumber.vue?vue&type=template&id=d354167c"
import script from "./FormNumber.vue?vue&type=script&lang=js"
export * from "./FormNumber.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__